import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Spin, Empty } from "antd";
import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import TableHeaderComponent from "../../../component/TableHeaderComponent";
import { constants } from "../../../constant/constants";
import InventoryTable from "../../../component/inventory/InventoryTable";
import ApiService from "../../../utils/ApiService";
import useUserStore from "../../../stores/store";
import { getInventoryListTableData } from "../../../services/inventory/inventory.service";
import { ROLES } from "../../../constant/constants";
import InventoryConfirmModal from "../../../component/inventory/InventoryConfirmModal";
import CustomLoader from "../../../component/menu/CustomLoader";

export default function Supplier() {
  const { user, restaurantId, showNotification, role, setNetworkCall } = useUserStore();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [listLoading, setListLoading] = useState(true);
  const [suppliers, setSuppliers] = useState();
  const [supplierDeleteId, setSupplierDeleteId] = useState("");
  const [openDelModal, setOpenDelModal] = useState(false);

  function onSearchText(value) {
    if (value === "") return;
    const val = value.trim();
    setSearchText(val);
    const params = {
      restaurantId: restaurantId,
      searchKey: val,
    };
    getSupplierList(params);
  }

  function onHandlePageChange(page, pageSize) {
    setPage(page);
    setPerPage(pageSize);
    const params = {
      restaurantId: restaurantId,
      searchKey: searchText,
      page,
      perPage: pageSize,
    };
    getSupplierList(params);
  }

  function onHandleEditItem(_id) {
    console.log("__edit__item", _id);
    navigate(`/inventory/supplier/${_id}/edit`);
  }

  async function onHandleDeleteItem(_id) {
    if (role === ROLES.STAFF) {
      showNotification("You are not authorize to delete this ingredient.");
      return;
    }
    setSupplierDeleteId(_id);
    setOpenDelModal(true);
  }

  async function getSupplierList(params) {
    setListLoading(true);
    if (!params) return;
    if (!params.hasOwnProperty("restaurantId")) {
      console.error("restaurantId is required for getting ingredient list.");
      return;
    }
    try {
      const res = await ApiService.GET_INVENTORY_SUPPLIER_LIST(params, user.token.token);
      if (res.code !== 200) {
        showNotification(res.data.message);
        setListLoading(false);
        return;
      }
      const { payload } = res;
      const { page, perPage, total, records } = payload;
      setPage(page);
      setPerPage(perPage);
      setTotal(total);
      setSuppliers(getInventoryListTableData(records, ["restaurantId", "ingredientNames"]));
      setListLoading(false);
    } catch (err) {
      setListLoading(false);
      showNotification(err.response.data.message);
      return;
    }
  }

  async function deleteSupplier(supplierId) {
    try {
      setNetworkCall(true);
      const res = await ApiService.INVENTORY_SUPPLIER_DELETE(supplierId, user.token.token);
      if (res.code !== 200) {
        setOpenDelModal(false);
        setNetworkCall(false);
        showNotification(res.data.message);
        return;
      }

      setOpenDelModal(false);
      setNetworkCall(false);
      const params = {
        restaurantId: restaurantId,
        searchText: searchText,
        page: page,
        perPage: perPage,
      };
      getSupplierList(params);
      showNotification("Supplier deleted successfully.", false);
      return;
    } catch (err) {
      setOpenDelModal(false);
      setNetworkCall(false);
      showNotification(err.response.data.message);
      return;
    }
  }

  useEffect(() => {
    getSupplierList({
      restaurantId: restaurantId,
    });
  }, []);

  function deleteSupplierAfterConfirmation() {
    deleteSupplier(supplierDeleteId);
    setSupplierDeleteId("");
  }

  function closeConfirmationModal() {
    setOpenDelModal(false);
    setSupplierDeleteId("");
  }

  function onHandleClearSearchBtn() {
    getSupplierList({
      restaurantId: restaurantId,
    });
  }

  return (
    <div className="flex flex-col">
      <CustomLoader />
      <Header title={`McDonalds Food Chains`} menu={constants.MENU.INVENTORY} currentMenuKey={"T_7_S_7_L_3"} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.INVENTORY} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] min-h-[90vh] ml-[72px]">
          <div className="flex flex-col w-full">
            <TableHeaderComponent
              pageRoute={"/inventory/supplier/add"}
              searchText={searchText}
              setSearchText={setSearchText}
              isDefaultSortByNeeded={false}
              record={{
                title: "Supplier List",
                hint: "Search keyword",
                search: onSearchText,
                onClearSearchText: onHandleClearSearchBtn,
              }}
            />
            <div>
              {listLoading ? (
                <div className="h-[50vh] flex items-center justify-center">
                  <Spin size="large" />
                </div>
              ) : Array.isArray(suppliers) && suppliers.length < 1 ? (
                <div className="h-[50vh] flex items-center justify-center">
                  <Empty />
                </div>
              ) : (
                <div>
                  <InventoryTable
                    data={suppliers}
                    coloredCols={["SN", "Supplier Name"]}
                    showEditButton={true}
                    handleEdit={onHandleEditItem}
                    handleDelete={onHandleDeleteItem}
                    paginationRecords={{
                      handlePageChange: onHandlePageChange,
                      page: page,
                      perPage: perPage,
                      setPerPage: setPerPage,
                      total: total,
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <InventoryConfirmModal
        open={openDelModal}
        title="Are you sure?"
        message="This will remove the supplier permanently."
        onConfirm={deleteSupplierAfterConfirmation}
        onCancel={closeConfirmationModal}
      />
    </div>
  );
}
